const AVATAR_PALETTE = [
  { bg: "#EFF6FF", color: "#1D4ED8" },
  { bg: "#ECFDF5", color: "#065F46" },
  { bg: "#FFF7ED", color: "#9A3412" },
  { bg: "#FDF4FF", color: "#7E22CE" },
  { bg: "#FFF1F2", color: "#9F1239" },
];

function getInitials(name) {
  return (name || "").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");
}

function AttainedBadge({ pct }) {
  if (pct === null || pct === undefined) {
    return <span className="text-xs text-gray-300">—</span>;
  }

  const num = parseFloat(pct);
  if (Number.isNaN(num)) {
    return <span className="text-xs text-gray-300">—</span>;
  }

  let bg, color;
  if (num >= 100)     { bg = "#DCFCE7"; color = "#166534"; }
  else if (num >= 80) { bg = "#FEF9C3"; color = "#854D0E"; }
  else                { bg = "#FEE2E2"; color = "#991B1B"; }
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold" style={{ background: bg, color }}>
      {num.toFixed(1)}%
    </span>
  );
}

function ProgressBar({ pct }) {
  if (pct === null || pct === undefined || Number.isNaN(parseFloat(pct))) {
    return <div className="flex-1 bg-gray-100 rounded-full h-1" />;
  }

  const width = Math.min(parseFloat(pct), 100);
  const color = width >= 100 ? "#22c55e" : width >= 80 ? "#eab308" : "#ef4444";
  return (
    <div className="flex-1 bg-gray-100 rounded-full h-1">
      <div className="h-1 rounded-full transition-all" style={{ width: `${width}%`, background: color }} />
    </div>
  );
}

const SalespersonTable = ({ salespersonWise }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4">
    <p className="text-xs font-semibold text-gray-700 uppercase tracking-wider mb-3">Salesperson-wise Sales</p>
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-gray-100">
            <th className="text-left pb-2 text-gray-400 font-medium min-w-[180px]">Name</th>
            <th className="text-right pb-2 text-gray-400 font-medium whitespace-nowrap">Revenue</th>
            <th className="text-right pb-2 text-gray-400 font-medium whitespace-nowrap">Orders</th>
            <th className="text-right pb-2 text-gray-400 font-medium whitespace-nowrap">AOV</th>
            <th className="text-right pb-2 text-gray-400 font-medium whitespace-nowrap">Return/Cancel</th>
            <th className="text-right pb-2 text-gray-400 font-medium whitespace-nowrap">Return Amount</th>
            <th className="text-right pb-2 text-gray-400 font-medium whitespace-nowrap">Target</th>
            <th className="text-right pb-2 text-gray-400 font-medium whitespace-nowrap">Attained</th>
            <th className="pb-2 pl-3 min-w-[80px]" />
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {(salespersonWise || []).map((sp, i) => {
            const palette = AVATAR_PALETTE[i % AVATAR_PALETTE.length];
            const pct = sp.attained_pct;
            return (
              <tr key={sp.id || i} className="hover:bg-gray-50/60 transition-colors">
                <td className="py-2.5">
                  <div className="flex items-center gap-2">
                    <span
                      className="inline-flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0"
                      style={{ width: 26, height: 26, background: palette.bg, color: palette.color }}
                    >
                      {getInitials(sp.name)}
                    </span>
                    <span className="font-medium text-gray-700 truncate">{sp.name}</span>
                  </div>
                </td>
                <td className="py-2.5 text-right font-semibold text-gray-800">{sp.revenue}</td>
                <td className="py-2.5 text-right text-gray-500">{sp.orders}</td>
                <td className="py-2.5 text-right text-gray-500">{sp.aov}</td>
                <td className="py-2.5 text-right text-red-500">
                  {sp.returns_cancellations?.count ?? 0}
                </td>
                <td className="py-2.5 text-right font-medium text-red-500 whitespace-nowrap">
                  {sp.returns_cancellations?.amount ?? "₹0.00"}
                </td>
                <td className="py-2.5 text-right text-gray-400">{sp.target ?? "—"}</td>
                <td className="py-2.5 text-right">
                  <AttainedBadge pct={pct} />
                </td>
                <td className="py-2.5 pl-3">
                  <ProgressBar pct={pct} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);

export default SalespersonTable;
